export default "__VITE_ASSET__D0vtkXzH__"